module.exports = __webpack_public_path__ + "static/media/4.38d03851.jpg";